import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/buyback/offer-graph.svg")